// import Vue from 'vue'
import consts from "@/consts"
import {arrayFilter_OnlyUnique} from "@/lib/lib";
import {getUnitGaleryIconSrc} from "@/lib/unit-galery";

export default {
    state: {
        map: {
            bounds: null,
            mapPaddingBounds: null,
            zoom: null,
            ...consts.map,

            unitsOnMap: [],
            unitsGroupsOnMap: [],

            geoitemEdit: null,
            geoitemsOnMap: [],

            showNotificationEvent: null,

            showShipmentEvent: null,
            mouseMoveUnit: null,

            isUnitsGroupsCluster: localStorage.getItem(process.env.VUE_APP_PRODUCT + '.isUnitsGroupsCluster') === 'true',
        },
    },
    actions: {
        setMapCenter({commit}, value) {
            commit('setMapCenter', value)
        },
        setMapView({commit}, args) {
            commit('setMapCenter', args.latlng)
            commit('setMapZoom', args.zoom)
        },
        setMapBounds({commit}, value) {
            commit('setMapBounds', value)
        },
        setMapPaddingBounds({commit}, value) {
            commit('setMapPaddingBounds', value)
        },
        setMapBoundsByUnitsGroups({dispatch, getters}, groupsIds) {
            let units = getters.getUnitsGroups
                .filter(g => groupsIds.find(id => id == g.id))
                .map(g => g?.units || [])
                .flat()
                .filter(arrayFilter_OnlyUnique)

            dispatch('setMapBoundsByUnits', units)
        },
        setMapBoundsByUnits({commit, getters}, unitsIds) {
            if (!unitsIds?.length) return false

            let bounds = unitsIds
                .map(id => getters.getUnitsLmsgsByIds[id]?.latlng)
                .filter(latlng => latlng)

            if (bounds.length > 1) {
                commit('setMapBounds', bounds)
            } else
            if (bounds.length == 1) {
                commit('setMapCenter', bounds[0])
            }
            //commit('setUnitsShowOnMap', { showOnMap: true, unitIds: units })
        },
        setMapBoundsByGeozones({commit, getters}, geoitems) {
            if (!geoitems || !geoitems.length) return false

            let bounds = geoitems.reduce((points, id) => {
                let geozone = getters.getGeozonesByIds[id]
                if (geozone?.points?.length) {
                    points.push(...geozone.points)
                    if(geozone.radius) {
                        let rd = geozone.radius / 111200
                        let ps = geozone.points.map(p => [
                            [+p[0] + rd, +p[1] + rd],
                            [+p[0] - rd, +p[1] - rd],
                        ]).flat(1)
                        points.push(...ps)
                    }
                }
                return points
            }, [])

            if (bounds.length > 1) {
                commit('setMapBounds', bounds)
            } else
            if (bounds.length == 1) {
                commit('setMapCenter', bounds[0])
            }
        },

        setGeoitemShowOnMap({commit}, args) {
            commit('setGeoitemShowOnMap', args)
        },
        setGeoitemsShowOnMap({commit}, args) {
            commit('setGeoitemsShowOnMap', args)
        },

        setUnitShowOnMap({commit}, args) {
            commit('setUnitShowOnMap', args)
        },
        setUnitsShowOnMap({commit}, args) {
            commit('setUnitsShowOnMap', args)
        },
        setAllUnitsShowOnMap({ commit}, args) {
            commit('setAllUnitsShowOnMap', args)
        },

        setGeoitemEdit({commit}, args) {
            commit('setGeoitemEdit', args)
        },
        patchGeoitemEdit({commit}, args) {
            commit('patchGeoitemEdit', args)
        },
        setEventShowOnMap({commit}, event) {
            commit('setEventShowOnMap', event)
            if (event && event.latlng) {
                commit('setMapCenter', event.latlng)
            }
        },
        setShipmentEventShowOnMap({commit}, event) {
            commit('setShipmentEventShowOnMap', event)
            if (event && event.latlng) {
                commit('setMapCenter', event.latlng)
            }
        },
        setUnitsGroupsCluster({commit}, value) {
            commit('setUnitsGroupsCluster', value)
        },
    },
    mutations: {
        setEventShowOnMap(state, event) {
            state.map.showNotificationEvent = !event?.latlng ? null : {
                xid: '',
                type: '',       //notification-event
                latlng: null,   //[]
                image: '',
                message: '',    //message || text
                text: '',
                ...event
            }
        },
        setShipmentEventShowOnMap(state, event) {
            state.map.showShipmentEvent = !event?.latlng ? null : {
                xid: '',
                type: '',       //notification-event
                latlng: null,   //[]
                image: '',
                message: '',    //message || text
                text: '',
                ...event
            }
        },

        setGeoitemEdit(state, geoitem) {
            state.map.geoitemEdit = geoitem
        },
        patchGeoitemEdit(state, patch) {
            if (state.map.geoitemEdit) {
                state.map.geoitemEdit = {
                    ...state.map.geoitemEdit,
                    ...patch
                }
            }
        },

        setMapCenter(state, center) {
            // console.log('setMapCenter', center)
            if (typeof center === 'string') {
                center = center.split(',')
            }
            if (Array.isArray(center) && center.length === 2) {
                state.map.center = {lat: center[0], lng: center[1]}
            } else
            if (center.lat && center.lng) {
                state.map.center = {lat: center.lat, lng: center.lng}
            } else {
                console.warn('setMapCenter', center)
            }
        },
        setMapZoom(state, value) {
            state.map.zoom = value
        },
        setMapBounds(state, value) {
            state.map.bounds = value
        },
        setMapPaddingBounds(state, value) {
            state.map.mapPaddingBounds = Object.freeze(value)
        },
        setGeoitemShowOnMap(state, args) {
            if (!args.showOnMap) {
                state.map.geoitemsOnMap = state.map.geoitemsOnMap
                    .filter(id => id != args.geoitemId)
            } else
            if (/*args.showOnMap &&*/ !state.map.geoitemsOnMap.includes(+args.geoitemId)) {
                state.map.geoitemsOnMap.push(+args.geoitemId)
            }
        },
        setGeoitemsShowOnMap(state, args) {
            if (!args.showOnMap) {
                state.map.geoitemsOnMap = state.map.geoitemsOnMap
                    .filter(id => !args.geoitemIds.includes(+id))
            } else {
                let ids = args.geoitemIds
                    .filter(id => !state.map.geoitemsOnMap.includes(+id))
                    .map(gId => +gId)
                state.map.geoitemsOnMap.push(...ids)
            }
        },
        setAllGeoitemsShowOnMap(state, geoitemIds) {
            state.map.geoitemsOnMap = [...geoitemIds].map(id => +id)
        },

        setUnitsGroupShowOnMap(state, args) {
            if (!args.showOnMap) {
                state.map.unitsGroupsOnMap = state.map.unitsGroupsOnMap
                    .filter(id => id != args.groupId)
            } else if (/*args.showOnMap &&*/ !state.map.unitsGroupsOnMap.includes(+args.groupId)) {
                state.map.unitsGroupsOnMap.push(+args.groupId)
            }
        },
        setUnitsGroupsOnMap(state, args) {
            if (!args.showOnMap) {
                state.map.unitsGroupsOnMap = state.map.unitsGroupsOnMap
                    .filter(id => !args.groupIds.includes(+id))
            } else {
                let ids = args.groupIds
                    .filter(id => !state.map.unitsGroupsOnMap.includes(+id))
                    .map(id => +id)
                state.map.unitsGroupsOnMap.push(...ids)
            }
        },
        setAllUnitsGroupsShowOnMap(state, groupIds) {
            state.map.unitsGroupsOnMap = [...groupIds].map(id => +id)
        },

        setUnitShowOnMap(state, args) {
            if (!args.showOnMap) {
                state.map.unitsOnMap = state.map.unitsOnMap.filter(id => {
                    return id !== args.unitId
                })
            } else
            if (/*args.showOnMap &&*/ !state.map.unitsOnMap.includes(args.unitId)) {
                state.map.unitsOnMap.push(args.unitId)
            }
        },
        setUnitsShowOnMap(state, args) {
            if (!args.showOnMap) {
                state.map.unitsOnMap = state.map.unitsOnMap.filter(id => {
                    return !args.unitIds.includes(id)
                })
            } else {
                let ids = args.unitIds.filter(id => {
                    return !state.map.unitsOnMap.includes(id)
                })
                state.map.unitsOnMap.push(...ids)
            }
        },
        setAllUnitsShowOnMap(state, unitIds) {
            state.map.unitsOnMap = [...unitIds]
        },
        setMouseMoveUnit(state, args) {
            state.map.mouseMoveUnit = args
        },
        setUnitsGroupsCluster(state, value) {
            state.map.isUnitsGroupsCluster = !!value
            localStorage.setItem(process.env.VUE_APP_PRODUCT + '.isUnitsGroupsCluster', !!value)
        },
    },
    getters: {
        isUnitsGroupsCluster(state) {
            return state.map.isUnitsGroupsCluster
        },
        getEventShowOnMap(state) {
            return state.map.showNotificationEvent
        },
        getShipmentEventShowOnMap(state) {
            return state.map.showShipmentEvent
        },
        getGeoitemEdit(state) {
            return state.map.geoitemEdit
        },
        getMapCenter(state) {
            return state.map.center
        },
        getMapZoom(state) {
            return state.map.zoom
        },
        getMapBounds(state) {
            return state.map.bounds
        },
        getMapPaddingBounds(state) {
            return state.map.mapPaddingBounds
        },

        getGeoitemsOnMap(state) {
            return state.map.geoitemsOnMap
        },
        getUnitsGroupsOnMap(state) {
            return state.map.unitsGroupsOnMap
        },
        getUnitsOnMap(state) {
            return state.map.unitsOnMap
        },

        getMouseMoveUnit(state) {
            return state.map.mouseMoveUnit
        },
        getUnitsStatusesById(_, getters) {
            return getters.getUnits.reduce((out, unit) => {
                let lmsg = getters.getUnitsLmsgsByIds[unit.id] || {}
                let status = '';
                if (!lmsg?.time) { //undef
                    status = 'not_connection'
                } else
                if (getters.getUnitsIdsIsOffline.includes(lmsg.object_id)) {
                    status = 'offline'
                } else
                if (lmsg?.status?.isMoving) {
                    status = 'moving';
                } else
                if (!lmsg?.status?.isMoving && lmsg?.status?.ignition) {
                    status = 'idling';
                } else
                if (!lmsg?.status?.isMoving) {
                    status = 'parked';
                }
                out[unit.id] = status;
                return out;
            }, {})
        },
        getUnitsMarkersOptionsByIds: (_, getters) => {
            return getters.getUnits.reduce((markersByIds, unit) => {
                let lmsg = getters.getUnitsLmsgsByIds[unit.id] || {}
                // let timeAgo = getters.getUnitsLmsgsTimeAgoByIds[unit.id]?.timeAgo
                let status = getters.getUnitsStatusesById[unit.id];
                let statusClass = consts?.statusesObjects?.find(s => s.id == status)?.class

                {
                    // let type = this.getUnitsTypes.find(t => t.id == unit.type)
                    // let unit_icon = "common__"+(type ? type.icon : 'car')+"_lg"
                    let icon_static_src = unit.icon_static ? getUnitGaleryIconSrc(unit.icon, status) : ''
                    // static icon without image in galery -> default sprite icon
                    let unit_icon = (unit.icon_static ? icon_static_src && unit.icon : unit.icon) || 'map__car_type_sedan'
                    let isDisabledRotateIcon = consts?.FilterSearchLists?.Units?.car_icons?.find(i => i.id == unit?.icon)?.disabledRotate
                    let icon_color = unit.icon_color || '#003B79'
                    let icon_has_halo = !!unit.icon_halo
                    let img_src = icon_static_src || '/img/icons.svg#' + unit_icon
                    // '/img/unit/'+unit_icon+'.svg'
                    // '/img/unit/common__car.png'
                    let course = +lmsg?.course || 0

                    markersByIds[unit.id] = {
                        id: unit.id,
                        name: unit.name,
                        name_: unit.name_,
                        hw_type: unit.hw_type,
                        type: unit.type,
                        icon: unit_icon,
                        icon_static: !!icon_static_src,
                        icon_color: icon_color,
                        icon_has_halo: icon_has_halo,

                        time: lmsg?.time,
                        latlng: lmsg?.latlng?.lat && lmsg?.latlng?.lng ? lmsg?.latlng : unit.coords,
                        course: course,
                        // speed: lmsg?.speed,

                        styleIcon: {
                            color: icon_color,
                            transform: course && !isDisabledRotateIcon ? 'rotate(' + course + 'deg);' : '',
                        },
                        // styleName: {},
                        img_src,
                        status,
                        statusClass
                    }
                }
                return markersByIds
            }, {})
        },
    }
}
